import { render, staticRenderFns } from "./PfStatementDownloadForm.vue?vue&type=template&id=7f8a9860"
import script from "./PfStatementDownloadForm.vue?vue&type=script&lang=js"
export * from "./PfStatementDownloadForm.vue?vue&type=script&lang=js"
import style0 from "./PfStatementDownloadForm.vue?vue&type=style&index=0&id=7f8a9860&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports